
export class MarketingSDK {
    constructor(appId = 'zei1mncq') {
      // if(window.Intercom){
      //   console.log("Intercom booting up...")
      //   window.Intercom("boot", {
      //     api_base: "https://api-iam.intercom.io",
      //     app_id: appId,
      //   });
      // }
    }
    async addUser({email, firstname='', lastname='', tags={}}) {
      console.log('MARKETING USER', {email, allTags: {...tags, firstname, lastname}})
      if(window.Intercom){
          Intercom('update', {
            "name": `${firstname} ${lastname}`,
            "email":email,
            "user_id":email,
            ...tags
          });
      }
    }
    async tagUser({key, value}) {
      if(window.Intercom){
        console.log('[MARKETING single TAG]', {key, value})
        let tags = {}
        tags[key] = value;
        Intercom('update', {
          ...tags
        });
      }

    }
    async addTagsToUser(tags) {
      console.log('[MARKETING TAGS]',tags)
        if(window.Intercom){
          Intercom('update', {
            ...tags
          });
        }
    }
}
